module.exports = __webpack_public_path__ + "dfee726a8a90a69c3c1025c76dffa999.ttf";